import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function BottomNav({ disabled, cart, bell, user, onPress }) {
 
    const navigate = useNavigate()
    const auth = {
        currentUser: JSON.parse(localStorage.getItem("user"))
    }


    useEffect(() => {

        if(!localStorage.getItem("name")) {
            navigate(`/auth-1/${auth?.currentUser?.uid}/configuration`)
        }

    }, [])

    if(cart) {
        return <div id="checkoutButton">
            <button disabled={disabled} onClick={onPress} style={{ marginBottom: 0, margin: "10px 0", backgroundColor: "var(--primary)" }}>Proceed to payments</button>
        </div>
    } 

    if(bell) {
        return <div id="checkoutButton">
            <button disabled={disabled} onClick={() => {
                navigate(`/auth-1/${auth.currentUser?.uid}`)
            }} style={{ marginBottom: 0, margin: "10px 0", backgroundColor: "var(--primary)" }}>Back To Shop</button>
        </div>
    }

    if(user) {
        return <div id="checkoutButton">
        <button disabled={disabled} onClick={async () => {
            localStorage.clear()
            navigate(`/getting-started`)
        }} style={{ marginBottom: 0, margin: "10px 0", backgroundColor: "var(--secondary)" }}>
            Sign Out
        </button>
    </div>
    }

    return (
        <div id="checkoutButton">
            <button disabled={disabled} onClick={() => {
                navigate(`/auth-1/${auth.currentUser?.uid}/cart`)
            }} style={{ marginBottom: 0, margin: "10px 0", backgroundColor: "var(--primary)" }}>Checkout</button>
        </div>
    )
}